import { reduxForm, SubmissionError } from 'redux-form';
import CreateApiKeyComponent from './CreateApiKeyComponent';
import { createApiKey } from '../../../redux/actions/apiKeyActions';
export default reduxForm({
  form: 'createApiKey',
  initialValues: {
    trading: false,
    deposit: false,
    withdraw: false,
    accountReadOnly: false
  },
  onSubmit: function onSubmit(payload, dispatch) {
    if (payload.deposit || payload.trading || payload.withdraw || payload.accountReadOnly) {
      dispatch(createApiKey(payload));
    } else {
      throw new SubmissionError({
        _error: 'Please choose at least one activity'
        //context.t('Please choose at least one activity')
      });
    }
  }
})(CreateApiKeyComponent);